import { Colors, type MediumIcon, TagColor } from '@factorialco/deprecated-design-system'
import {
  FinanceValueObjectsAllocationStatusEnum,
  FinanceValueObjectsBudgetStatusEnum,
  FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface BudgetAlertBadge {
  icon: MediumIcon
  color: Colors
  iconColor: Colors
}
export const budgetAlertBadge = (
  budgetStatus: FinanceValueObjectsBudgetStatusEnum | null | undefined,
  allocationStatus: FinanceValueObjectsAllocationStatusEnum | null | undefined
): BudgetAlertBadge => {
  if (budgetStatus === 'over_budget' || allocationStatus === 'over_allocation')
    return {
      icon: 'alert-circle',
      color: 'radicalRed200',
      iconColor: 'radicalRed1000',
    }
  if (budgetStatus === 'budget_risk' || allocationStatus === 'allocation_risk')
    return {
      icon: 'alert-circle',
      color: 'tangerine200',
      iconColor: 'tangerine1000',
    }
  return {
    icon: 'check',
    color: 'lime200',
    iconColor: 'lime1000',
  }
}

export const policyAlertBadge = (
  policyResult: FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnum | null | undefined
): BudgetAlertBadge => {
  if (policyResult === 'out_of_policy')
    return {
      icon: 'alert-circle',
      color: 'radicalRed200',
      iconColor: 'radicalRed1000',
    }
  else
    return {
      icon: 'check',
      color: 'lime200',
      iconColor: 'lime1000',
    }
}

const workflowPolicyAlertBadge = (): BudgetAlertBadge => {
  return {
    icon: 'alert-circle',
    color: 'radicalRed200',
    iconColor: 'radicalRed1000',
  }
}

export const budgetStatusTag = (status: FinanceValueObjectsBudgetStatusEnum) => {
  switch (status) {
    case 'over_budget':
      return {
        color: TagColor.radical,
        text: i18n.t('budgets.status.over_budget'),
      }
    case 'budget_risk':
      return {
        color: TagColor.tangerine,
        text: i18n.t('budgets.status.budget_risk'),
      }
    case 'within_budget':
      return {
        color: TagColor.lime,
        text: i18n.t('budgets.status.within_budget'),
      }
    default:
      throw new Error(`Unhandled budget status: ${status}`)
  }
}

export const allocationStatusTag = (status: FinanceValueObjectsAllocationStatusEnum) => {
  switch (status) {
    case 'over_allocation':
      return {
        color: TagColor.radical,
        text: i18n.t('budgets.allocation_status.over_allocation'),
      }
    case 'allocation_risk':
      return {
        color: TagColor.tangerine,
        text: i18n.t('budgets.allocation_status.allocation_risk'),
      }
    case 'within_allocation':
      return {
        color: TagColor.lime,
        text: i18n.t('budgets.allocation_status.within_allocation'),
      }
    default:
      throw new Error(`Unhandled allocation status: ${status}`)
  }
}

export const syncAlertBadge = (): BudgetAlertBadge => {
  return {
    icon: 'alert-circle',
    color: 'radicalRed200',
    iconColor: 'radicalRed1000',
  }
}
